// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cancel-account-container {
	display: inline;
	white-space: nowrap;
	padding-left: 1em;
	padding-right: 1em;
}

.cancel-account-link {
	font-size: 14px;
	color: red;
	text-decoration: none;
	line-height: 24px;
	cursor: pointer;
}

.cancel-account-overlay {
	position: fixed;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	height: 100%;
	background: #000;
	opacity: .7;
	z-index: 5000;
}

.cancel-account-prompt-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow-y: auto !important;
}

.cancel-account-prompt {
	margin-top: 5em;
	background: white;
	width: 600px;
	border: 1px solid black;
	border-radius: 5px;
	padding: 1em;
	z-index: 5002;
	font-size: 1.5em;
	max-width: calc(100% - 2px);
	box-sizing: border-box;
}

.cancel-account-prompt .cancel-account-statement {
	margin: 1em 0em;
	white-space: normal;
}

.cancel-account-prompt .cancel-account-action {
	display: block;
	border-top: 1px solid gray;
	cursor: pointer;
	margin-top: .5em;
	padding-top: .5em;
	text-align: center;
}

.cancel-account-prompt .cancel-account-action.cancel-account-confirm {
	color: red;
	white-space: normal;
}

.cancel-account-spinner-container {
	text-align: center;
}

.cancel-account-spinner {
	font-size: 64px;
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/CancelAccount.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,UAAU;CACV,qBAAqB;CACrB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,OAAO;CACP,MAAM;CACN,SAAS;CACT,QAAQ;CACR,YAAY;CACZ,gBAAgB;CAChB,WAAW;CACX,aAAa;AACd;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,YAAY;CACZ,uBAAuB;CACvB,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,gBAAgB;CAChB,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,0BAA0B;CAC1B,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB","sourcesContent":[".cancel-account-container {\n\tdisplay: inline;\n\twhite-space: nowrap;\n\tpadding-left: 1em;\n\tpadding-right: 1em;\n}\n\n.cancel-account-link {\n\tfont-size: 14px;\n\tcolor: red;\n\ttext-decoration: none;\n\tline-height: 24px;\n\tcursor: pointer;\n}\n\n.cancel-account-overlay {\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tbottom: 0;\n\tright: 0;\n\theight: 100%;\n\tbackground: #000;\n\topacity: .7;\n\tz-index: 5000;\n}\n\n.cancel-account-prompt-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\toverflow-y: auto !important;\n}\n\n.cancel-account-prompt {\n\tmargin-top: 5em;\n\tbackground: white;\n\twidth: 600px;\n\tborder: 1px solid black;\n\tborder-radius: 5px;\n\tpadding: 1em;\n\tz-index: 5002;\n\tfont-size: 1.5em;\n\tmax-width: calc(100% - 2px);\n\tbox-sizing: border-box;\n}\n\n.cancel-account-prompt .cancel-account-statement {\n\tmargin: 1em 0em;\n\twhite-space: normal;\n}\n\n.cancel-account-prompt .cancel-account-action {\n\tdisplay: block;\n\tborder-top: 1px solid gray;\n\tcursor: pointer;\n\tmargin-top: .5em;\n\tpadding-top: .5em;\n\ttext-align: center;\n}\n\n.cancel-account-prompt .cancel-account-action.cancel-account-confirm {\n\tcolor: red;\n\twhite-space: normal;\n}\n\n.cancel-account-spinner-container {\n\ttext-align: center;\n}\n\n.cancel-account-spinner {\n\tfont-size: 64px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
